import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-type-boolean",
  "use": "icon-type-boolean-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-type-boolean\"><path d=\"M26.668 7.11v17.78H5.332V7.11zm-1.777 1.78H16v14.22h8.89zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol